export type RuntimeAnswer = {
  answer?: string;
  sources?: string[];
  metadata?: Record<string, unknown>;
};

export function prettyPrintJson(value: unknown): string {
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export function formatInvocationError(error: unknown): string {
  if (typeof error === "string") {
    const trimmed = error.trim();
    if (
      (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
      (trimmed.startsWith("[") && trimmed.endsWith("]"))
    ) {
      try {
        return prettyPrintJson(JSON.parse(trimmed));
      } catch {
        return error;
      }
    }
    return error;
  }
  return prettyPrintJson(error);
}

export function parseRuntimeResult(result: unknown): RuntimeAnswer | null {
  if (!result || typeof result !== "object") {
    return null;
  }

  const outer = result as { result?: unknown; answer?: unknown };
  if (outer.result && typeof outer.result === "object") {
    const inner = outer.result as RuntimeAnswer;
    if (typeof inner.answer === "string" || Array.isArray(inner.sources)) {
      return inner;
    }
  }

  if (typeof outer.answer === "string" || Array.isArray(outer.sources)) {
    return outer as RuntimeAnswer;
  }

  return null;
}
